import React from 'react';
import Layout from "../components/Layout";
import App from "../components/ProjectComparison";

const CPDashboard = () => {
  return (
    <Layout>
      <App />
    </Layout>
  );
};

export default CPDashboard;
